import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  viewBox: '-1 -1 34 34'
}, [
  h('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#8091A5',
    d: 'M32 16c0 8.8-7.2 16-16 16S0 24.8 0 16 7.2 0 16 0s16 7.2 16 16zm-24.3-.8c.1-2.2.5-4.4 1.1-6.4H3.5c-1.1 1.9-1.8 4.1-1.9 6.4h6.1zm7.5-6.4h-4.8c-.7 2-1.1 4.1-1.2 6.4h6V8.8zm0-7.2c-1.7 1.5-3.1 3.4-4.1 5.7h4.1V1.6zM4.5 7.3h4.9c.8-2 2-3.8 3.3-5.3-3.4.7-6.3 2.7-8.2 5.3zm25.9 7.9c-.1-2.3-.8-4.5-1.9-6.4h-5.3c.7 2 1 4.1 1.1 6.4h6.1zm-13.6 0h6c-.1-2.2-.5-4.4-1.2-6.4h-4.8v6.4zm0-7.9h4.1c-1-2.2-2.4-4.2-4.1-5.7v5.7zM19.3 2c1.3 1.5 2.4 3.3 3.3 5.3h4.9c-1.9-2.6-4.8-4.6-8.2-5.3zM1.6 16.8c.1 2.3.8 4.5 1.9 6.4h5.3c-.7-2-1-4.1-1.1-6.4H1.6zm13.6 0h-6c.1 2.2.5 4.4 1.2 6.4h4.8v-6.4zm0 7.9h-4.1c1 2.2 2.4 4.2 4.1 5.7v-5.7zM12.7 30c-1.3-1.5-2.4-3.3-3.3-5.3H4.5c1.9 2.6 4.8 4.6 8.2 5.3zm11.6-13.2c-.1 2.2-.5 4.4-1.1 6.4h5.3c1.1-1.9 1.8-4.1 1.9-6.4h-6.1zm-7.5 6.4h4.8c.7-2 1.1-4.1 1.2-6.4h-6v6.4zm0 7.2c1.7-1.5 3.1-3.4 4.1-5.7h-4.1v5.7zm10.7-5.7h-4.9c-.8 2-2 3.8-3.3 5.3 3.4-.7 6.3-2.7 8.2-5.3z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/language-http.es6.js